// extracted by mini-css-extract-plugin
export var banner = "_33-0";
export var icon = "_33-1";
export var message = "_33-2";